export class OurPartner {
    static fromOurPartnersResponse(data) {
        var ref;
        return new OurPartner((ref = data.avatarKey) === null || ref === void 0 ? void 0 : ref.key, data.id, data.name, data.link);
    }
    toJSON() {
        return {
            avatar_key: this.avatar_key,
            id: this.id,
            name: this.name,
            link: this.link,
            avatar_url: this.avatar_key
        };
    }
    get avatar_url() {
        if (!this.avatar_key) return this.avatar_key;
        return "/api/utils-pages/images?imageKey=".concat(this.avatar_key);
    }
    constructor(avatar_key, id, name, link){
        this.avatar_key = avatar_key;
        this.id = id;
        this.name = name;
        this.link = link;
    }
}
